import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * Global "not a broker" legal disclaimer.
 * Renders as a thin, persistent footer strip on every page so the
 * platform's SaaS-only positioning is always visible to users and auditors.
 */
const PlatformDisclaimer = () => (
  <div
    data-testid="platform-disclaimer"
    className="w-full bg-amber-500/10 border-t border-amber-500/30 text-amber-200 text-[11px] leading-snug px-4 py-2 text-center"
  >
    <div className="max-w-5xl mx-auto flex items-start sm:items-center gap-2 justify-center flex-wrap">
      <ShieldAlert className="w-3.5 h-3.5 shrink-0" />
      <span>
        <strong>Tempus Dispatch LLC is a SaaS platform and carrier dispatch agent. Not a freight broker. Not liable for freight transactions. (49 USC § 13904)</strong>
        {' '}
        <a href="/terms" className="underline hover:text-amber-100">Terms</a>
        {' · '}
        <a href="/privacy" className="underline hover:text-amber-100">Privacy</a>
      </span>
    </div>
  </div>
);

export default PlatformDisclaimer;
